import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import axios from 'axios';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  message: any = null;

  constructor(private route: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const authSession = localStorage.getItem('_');
    if (authSession != null || authSession != undefined) {
      this.route.navigate(['/'], { queryParams: this.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' });
      return;
    }
  }

  signIn(username: any, pwd: any) {
    this.message = null;
    const that = this;
    if (username.trim() == '' || pwd.trim() == '') {
      this.message = 'Username or password invalid';
      return;
    }
    let formData = new FormData();
    formData.append('username', username.trim());
    formData.append('password', pwd.trim());
    let uri = encodeURIComponent(`${environment.music}/apilogin`);
    axios.post(`/pass/${uri}`, formData)
      .then(function (response) {
        if (response.data.status == 1) {
          response.data.token = btoa(response.data.token);
          localStorage.setItem('_', btoa(JSON.stringify(response.data)));
          that.route.navigate(['/'], { queryParams: that.activatedRoute.snapshot.queryParams, queryParamsHandling: 'merge' }).then(() => {
            window.location.reload();
          });
        } else {
          that.message = 'Username or password incorrect';
        }
      })
      .catch(function (error) {
        console.log(error);
        that.message = 'See the JavaScript console for technical details';
      });
  }
}
